import Selectable, {SelectableProps} from "./selectable.element";
import {Tooltip} from "@mui/material";
import {useFieldDoc} from "./useFieldDoc";

interface SelectableLabelProps<T> extends SelectableProps<T> {
    // Optional: omitted when `field` supplies the label from the model's [FieldDoc].
    name?: string;
    tooltip?: string;
    // Manifest field key (e.g. "building.countsAs") — sources the label + tooltip
    // from the Client model. An explicit name/tooltip always wins.
    field?: string;
}

function SelectableLabel<T extends string | number>(props: SelectableLabelProps<T>) {
    const {label, tip} = useFieldDoc({field: props.field, title: props.name, tooltip: props.tooltip});
    return (
        <div className={'layout horizontal center stretch'} style={props.style}>
            <div className={'layout horizontal center gap'}>
                {tip
                    ? <Tooltip title={tip} arrow disableInteractive>
                        <p style={{cursor: 'help'}}>{label}</p>
                    </Tooltip>
                    : <p>{label}</p>}
            </div>
            <Selectable value={props.value} options={props.options} groups={props.groups}
                        literalOptions={props.literalOptions} placeholder={props.placeholder} onChange={props.onChange}/>
        </div>
    )
}

export default SelectableLabel;